module.exports = __webpack_public_path__ + "static/media/whiteShirt.1e2a62eb.jpg";